import { Injectable } from "@angular/core";
import { ID } from "@common/interfaces/id";
import { IID_OL_ACQUISITO_KO } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, StoreConfig, EntityStore } from "@datorama/akita";

export interface IIDolAquisitiKoState extends EntityState<IID_OL_ACQUISITO_KO, ID> { }

@Injectable({
  providedIn: 'root'
})
@StoreConfig({ name: Topics.IID_OL_ACQUISITO_KO })
export class IIDolAquisitiKoStore extends EntityStore<IIDolAquisitiKoState> {
  constructor() {
    super([]);
  }
}
